import { useEffect, useState } from 'react';
import AddOnsInfoV2 from './AddOnsInfoV2';
import BuyCreatorPlanAndUploadPlan from './BuyCreatorPlanAndUploadPlan';
import { RECURRING_INTERVAL } from './subscriptionHelper';
import { useSelector } from 'react-redux';
import { selectCurrentLoggedInInfo } from '../../redux/slicers/activitySlicer';
import useCurrentOrganizationInfo from '../../hooks/useCurrentOrganizationInfo';

export const CombinePlanAndAddonsPurchase = ({
  modifySubscription,
  wuSelectedPlanId,
  wuSelectedPlanPriceId,
  wuSelectedInterval,
  setPlanLoading,
  setModifySubscription = () => {},
  // showLimitedAddons = false
}) => {
  const [selfServeBillingCycle, setSelfServeBillingCycle] = useState(RECURRING_INTERVAL.MONTH);
  const [openCheckout, setOpenCheckout] = useState(false);
  const [updateCheckoutAmount, setUpdateCheckoutAmount] = useState(0);
  const { isFreemiumUser } = useSelector(selectCurrentLoggedInInfo);
  const [isAddToPlanClickedLoading, setIsAddToPlanClickedLoading] = useState(false);
  const { isFreemiumUser:isFreemiumUserFlag } = useCurrentOrganizationInfo()

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params?.get('uploadPlanType')) {
      setModifySubscription(true);
    }
  }, []);

  return (
    <>
      {!isFreemiumUserFlag && (
        <BuyCreatorPlanAndUploadPlan
          {...{
            modifySubscription,
            wuSelectedPlanId,
            wuSelectedPlanPriceId,
            wuSelectedInterval,
            setPlanLoading,
            selfServeBillingCycle,
            setSelfServeBillingCycle,
            setUpdateCheckoutAmount,
            isAddToPlanClickedLoading,
            setIsAddToPlanClickedLoading,
          }}
          openCheckoutPage={() => setOpenCheckout(true)}
          containerStyle={
            isFreemiumUser
              ? {
                  borderBottomLeftRadius: 0,
                  borderBottomRightRadius: 0,
                }
              : {}
          }
        />
      )}
      {/* {isFreemiumUser && !showLimitedAddons ? ( */}
      {/* {isFreemiumUser ? (
        <div
          style={{
            borderTop: '1px solid #e7e7e7',
            width: 'calc(100% - 48px)',
            margin: '-1px auto 0',
          }}></div>
      ) : null} */}
      <AddOnsInfoV2
        {...{
          setModifySubscription,
          modifySubscription,
          selfServeBillingCycle,
          setSelfServeBillingCycle,
          openCheckout,
          setOpenCheckout,
          updateCheckoutAmount,
          setUpdateCheckoutAmount,
          isAddToPlanClickedLoading,
        }}
        // showLimitedAddons={showLimitedAddons}
        showSeparateList={false}
        innerContainerStyle={
          isFreemiumUser
            ? {
                marginTop: '-24px',
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
              }
            : {}
        }
      />
    </>
  );
};
